import moment from 'moment';

export const getFormattedDuration = (duration: number) => {
    const d = moment.duration(duration, 'minutes');
    return moment.utc(d.asMilliseconds()).format('HH ч. mm м.');
};
